import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { BlockUIModule } from 'ng-block-ui';
import { NgbModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { TagInputModule } from 'ngx-chips';
import { NgxMaskModule } from 'ngx-mask';
import { SocialLoginModule, AuthServiceConfig } from 'angular5-social-login';

import { getAuthServiceConfigs } from '../sociallogin.config';

import { DefaultIfEmpty } from '../helpers/app.pipes';

import {
  MessageService, MasterDataService, AccountService, ContestService, ContestFilterService, CreationService,
  GalleryService, ContentPageService, SupportRequestService, CustomerService
} from '../services';

import { AppSettings, AppUtils, JwtInterceptor, AuthGuard, NgbCustomDateParserFormatter } from '../helpers';

import { AppComponent } from './app.component';
import { HeaderComponent, FooterComponent, PrivacyComponent, TermsComponent } from '../components/shared';
import {
  RegisterComponent, AccountCreatedComponent, AccountConfirmComponent, LoginComponent, LogoutComponent,
  AccountRecoverComponent, AccountResetComponent
} from '../components/account';
import {
  ContentSearchResultComponent, ContestDetailComponent,
  ContestSubmissionsComponent, JoinContestComponent, ContestArtistComponent
} from '../components/contest';
import { UserGalleryComponent, GallerySearchResultComponent } from '../components/gallery';
import { CreationSearchResultComponent } from '../components/creation';
import { CreatorSearchResultComponent } from '../components/creator';
import { ContentPageComponent } from '../components/content-page/content.page.component';
import { ProfileDetailComponent, ProfileEditComponent } from '../components/user';
import { ContactUsComponent } from '../components/miscellaneous';

@NgModule({
  declarations: [
    DefaultIfEmpty,
    AppComponent,
    HeaderComponent,
    FooterComponent,
    RegisterComponent,
    LoginComponent,
    LogoutComponent,
    AccountCreatedComponent,
    AccountConfirmComponent,
    AccountRecoverComponent,
    AccountResetComponent,
    ContentSearchResultComponent,
    ContestDetailComponent,
    ContestSubmissionsComponent,
    ContestArtistComponent,
    JoinContestComponent,
    CreationSearchResultComponent,
    CreatorSearchResultComponent,
    UserGalleryComponent,
    GallerySearchResultComponent,
    ContentPageComponent,
    ProfileDetailComponent,
    ProfileEditComponent,
    ContactUsComponent,
    PrivacyComponent,
    TermsComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    SocialLoginModule,
    TagInputModule,
    NgbModule.forRoot(),
    NgxPaginationModule,
    ToastModule.forRoot(),
    BlockUIModule.forRoot(),
    NgxMaskModule.forRoot(),
    RouterModule.forRoot([
      { path: '', component: ContentSearchResultComponent },
      // { path: 'account/register', component: RegisterComponent },
      { path: 'account/login', component: LoginComponent },
      { path: 'account/logout', component: LogoutComponent },
      { path: 'account/created/:id', component: AccountCreatedComponent },
      { path: 'account/confirm', component: AccountConfirmComponent },
      { path: 'account/recover', component: AccountRecoverComponent },
      { path: 'account/reset', component: AccountResetComponent },
      { path: 'contest/filter', component: ContentSearchResultComponent },
      { path: 'contest/detail/:id', component: ContestDetailComponent },
      { path: 'contest/join/:id', component: JoinContestComponent, canActivate: [AuthGuard] },
      { path: 'creation/filter', component: CreationSearchResultComponent },
      { path: 'creator/filter', component: CreatorSearchResultComponent },
      { path: 'gallery/my-gallery', component: UserGalleryComponent, canActivate: [AuthGuard] },
      { path: 'user/profile-detail', component: ProfileDetailComponent, canActivate: [AuthGuard] },
      { path: 'user/profile-edit', component: ProfileEditComponent, canActivate: [AuthGuard] },
      { path: 'about-us', component: ContentPageComponent },
      { path: 'contact-us', component: ContactUsComponent },
      { path: 'privacy-policy', component: PrivacyComponent },
      { path: 'terms-and-conditions', component: TermsComponent },
      { path: '**', redirectTo: '/', pathMatch: 'full' },
    ])
  ],
  providers: [
    AppSettings,
    AppUtils,
    AuthGuard,
    MessageService,
    ContestFilterService,
    MasterDataService,
    AccountService,
    ContestService,
    CreationService,
    GalleryService,
    ContentPageService,
    SupportRequestService,
    CustomerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    },
    {
      provide: AuthServiceConfig,
      useFactory: getAuthServiceConfigs
    },
    {
      provide: NgbDateParserFormatter,
      useClass: NgbCustomDateParserFormatter
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts